export default "__VITE_ASSET__BT76yjjG__";